import { configUiMenu_mobile_vertical as  configUiMenu_default} from "src/library/minigame_client/ui/menu"

export let configUiMenu_mobile_horizontal = _.cloneDeep(configUiMenu_default);

const resourcesUiMenu_mobile_horizontal = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/common/minigames/sounds/btn_click",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/common/minigames/menu/mobile_vertical/common.json",
            {name: "res/common/minigames/menu/mobile_vertical/menu.json", rus: true},
        ]
};

configUiMenu_mobile_horizontal.resources = resourcesUiMenu_mobile_horizontal;
configUiMenu_mobile_horizontal.packFolder = "minigames_menu_mobile_vertical/";
configUiMenu_mobile_horizontal.sndBtnClick = "res/sounds/btn_click";
configUiMenu_mobile_horizontal.buttonHelpPosition =     {x: 452, y: 5};
configUiMenu_mobile_horizontal.buttonSettingsPosition = {x: 534, y: 5};
configUiMenu_mobile_horizontal.buttonAutoOnPosition =   {x: 615, y: 5};
configUiMenu_mobile_horizontal.buttonAutoOffPosition =  {x: 615, y: 5};
configUiMenu_mobile_horizontal.buttonExitPosition =     {x: 110, y: 5};
configUiMenu_mobile_horizontal.buttonSoundOnPosition =  {x: 195, y: 5};
configUiMenu_mobile_horizontal.buttonSoundOffPosition = {x: 195, y: 5};


//////////////////
// WEBPACK FOOTER
// ./cfg/mobile_horizontal/menu.es6
// module id = 43
// module chunks = 0